
import Vue from 'vue'
import axios, { Axios } from 'axios'
import * as Sentry from '@sentry/vue'
import { Component } from 'vue-property-decorator'
import ListComponent from '../../global/components/List/index.vue'
import { DistributorRelationship } from '../../global/models'
import { consumeError } from '../../global/utils'
import { prettyDateTime } from '@/domains/global/functions/util'

@Component({
  components: { ListComponent }
})
export default class DistributorListPage extends Vue {
  get filterOptions() {
    return [
      { text: 'ID', key: 'id', type: 'number' },
      { text: 'Given Name', key: 'givenName', type: 'string' },
      { text: 'Surname', key: 'surname', type: 'string' },
      { text: 'Email', key: 'email', type: 'string' },
      { text: 'relationshipStatus', key: 'relationshipStatus', type: 'string' }
    ]
  }

  get availableColumns() {
    return [
      { text: 'Given Name', value: 'givenName' },
      { text: 'Surname', value: 'surname' },
      { text: 'Email', value: 'email' },
      { text: 'Relationship Status', value: 'relationshipStatus' },
      { text: 'Created', value: 'created', type: 'date', display: (date?: string) => prettyDateTime(date) },
      { text: 'Updated', value: 'updated', type: 'date', display: (date?: string) => prettyDateTime(date) }
    ]
  }

  get defaultColumns() {
    return ['givenName', 'surname', 'email', 'relationshipStatus', 'created', 'updated']
  }
  
  get actions() {
    return [
      { text: 'View', method: (relationship: DistributorRelationship) => this.viewUser(relationship) },
      { text: 'Edit', method: (relationship: DistributorRelationship) => this.editUser(relationship) },
      { text: 'Disable', method: (relationship: DistributorRelationship) => this.disable(relationship), visible: (relationship: DistributorRelationship) => relationship.relationshipStatus !== 'disabled' },
      { text: 'Enable', method: (relationship: DistributorRelationship) => this.enable(relationship), visible: (relationship: DistributorRelationship) => relationship.relationshipStatus !== 'active' }
    ]
  }

  get list() {
    return this.$refs.list as ListComponent<DistributorRelationship>
  }

  viewUser(relationship: DistributorRelationship) {
    this.$router.push({ name: 'distributors-read', params: { id: relationship.id.toString() } })
  }

  editUser(relationship: DistributorRelationship) {
    this.$router.push({ name: 'distributors-edit', params: { id: relationship.id.toString() } })
  }

  async disable(relationship: DistributorRelationship) {
    try {
      await axios.put(`/distributors/${relationship.id}/disable`)
      this.list.updateResults()
    } catch (error) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  async enable(relationship: DistributorRelationship) {
    try {
      await axios.put(`/distributors/${relationship.id}/enable`)
      this.list.updateResults()
    } catch (error) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  createRelationship() {
    this.$router.push({ name: 'distributors-create' })
  }
}
